var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-profile",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    width: 26,
    height: 26,
    transform: "translate(3 3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_21",
    "data-name": "Exclusion 21",
    d: "M21.261,26H19.433a.566.566,0,0,1-.56-.5l-.156-1.244a4.218,4.218,0,0,1-.926-.55l-1.172.5a.561.561,0,0,1-.218.044.569.569,0,0,1-.491-.283L15,22.382a.566.566,0,0,1,.149-.734l1.018-.77c-.005-.043-.011-.086-.017-.129a2.982,2.982,0,0,1-.036-.4,3.082,3.082,0,0,1,.038-.418v-.01c0-.034.009-.067.014-.1l-1.018-.77A.568.568,0,0,1,15,18.313l.915-1.582a.566.566,0,0,1,.709-.239l1.172.494a4.228,4.228,0,0,1,.926-.55l.156-1.244a.567.567,0,0,1,.561-.5h1.828a.566.566,0,0,1,.561.5l.156,1.244a4.217,4.217,0,0,1,.926.55l1.173-.494a.558.558,0,0,1,.217-.044.568.568,0,0,1,.491.283l.915,1.582a.568.568,0,0,1-.147.735l-1.018.77c.005.042.011.083.016.125a2.992,2.992,0,0,1,.037.405,3.081,3.081,0,0,1-.038.42c-.005.039-.01.075-.015.111l1.017.769a.567.567,0,0,1,.148.734l-.915,1.584a.566.566,0,0,1-.489.283.558.558,0,0,1-.219-.045L22.9,23.71a4.228,4.228,0,0,1-.926.55L21.822,25.5A.565.565,0,0,1,21.261,26Zm-.914-7.913a2.261,2.261,0,1,0,2.261,2.261A2.263,2.263,0,0,0,20.348,18.087Zm-7.18,5.653H.848A.849.849,0,0,1,0,22.891V18.935a5.376,5.376,0,0,1,5.37-5.37h9.608a5.348,5.348,0,0,1,1.962.383l-.023.044c-.038.073-.077.147-.108.224A2.827,2.827,0,0,0,13.953,15.6l-.915,1.582a2.816,2.816,0,0,0,.229,3.165,2.816,2.816,0,0,0-.229,3.166l.128.224ZM10.174,11.305a5.653,5.653,0,1,1,5.653-5.653A5.658,5.658,0,0,1,10.174,11.305Z",
    transform: "translate(3 3)",
    fill: "#3398cb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileSelect);
export default __webpack_public_path__ + "static/media/icon-profile-select.732b324bf50d5088b872fab9758ac111.svg";
export { ForwardRef as ReactComponent };